<template>
    <expo-program-item v-bind="{ value: program }">
        <template #actions>
            <template v-if="!isUserLoggedIn">
                <dialog-login>
                    <template #activator="{ attrs, on }">
                        <v-btn small color="primary" class="w-120px" v-bind="attrs" v-on="on">
                            <span> 로그인 하기 </span>
                        </v-btn>
                    </template>
                </dialog-login>
            </template>
            <template v-else-if="isUserHost">
                <expo-program-form v-bind="{ value: program }" @input="setProgramAndInit">
                    <template #activator="{ attrs, on }">
                        <v-btn small color="primary" class="w-120px" v-bind="attrs" v-on="on">
                            <span> 프로그램 수정 </span>
                        </v-btn>
                    </template>
                </expo-program-form>
            </template>
            <template v-else-if="!!employee">
                <v-row class="row--small">
                    <v-col cols="auto">
                        <expo-employee-form :value="employee" v-bind="{ program }" @input="setEmployeeAndInit">
                            <template #activator="{ attrs, on }">
                                <v-btn small color="primary" class="w-120px" v-bind="attrs" v-on="on">
                                    <span> 지원정보 수정 </span>
                                </v-btn>
                            </template>
                        </expo-employee-form>
                    </v-col>
                    <v-col cols="auto">
                        <expo-employee-remove v-bind="{ value: employee }" @search="init">
                            <template #activator="{ attrs, on }">
                                <v-btn small outlined color="grey-d" class="w-120px" v-bind="attrs" v-on="on">
                                    <span class="grey--text"> 참여신청 취소 </span>
                                </v-btn>
                            </template>
                        </expo-employee-remove>
                    </v-col>
                </v-row>
            </template>
            <template v-else-if="!!employer">
                <v-row class="row--small">
                    <v-col cols="auto">
                        <expo-employer-form :value="employer" v-bind="{ program }" @input="setEmployerAndInit">
                            <template #activator="{ attrs, on }">
                                <v-btn small color="primary" class="w-120px" v-bind="attrs" v-on="on">
                                    <span> 지원정보 수정 </span>
                                </v-btn>
                            </template>
                        </expo-employer-form>
                    </v-col>
                    <v-col cols="auto">
                        <expo-employer-remove v-bind="{ value: employer }" @search="init">
                            <template #activator="{ attrs, on }">
                                <v-btn small outlined color="grey-d" class="w-120px" v-bind="attrs" v-on="on">
                                    <span class="grey--text"> 참여신청 취소 </span>
                                </v-btn>
                            </template>
                        </expo-employer-remove>
                    </v-col>
                </v-row>
            </template>
            <template v-else-if="!doesUserHaveConsoleScope">
                <expo-program-apply v-bind="{ program }" v-on="{ setEmployee }">
                    <template #activator="{ attrs, on, loading }">
                        <v-btn small color="primary" class="w-120px" v-bind="{ ...attrs, loading }" v-on="on">
                            <span> 참여 신청하기 </span>
                        </v-btn>
                    </template>
                </expo-program-apply>
            </template>
        </template>
    </expo-program-item>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import DialogLogin from "@/components/client/login/dialog-login.vue";
import ExpoProgramItem from "@/components/dashboard/common/expo/program/expo-program-item.vue";
import ExpoProgramForm from "@/components/dashboard/company/expo/program/expo-program-form.vue";
import ExpoEmployeeForm from "@/components/client/expo/employee/expo-employee-form.vue";
import ExpoEmployeeRemove from "@/components/client/expo/employee/expo-employee-remove.vue";
import ExpoEmployerForm from "@/components/client/expo/employer/expo-employer-form.vue";
import ExpoEmployerRemove from "@/components/client/expo/employer/expo-employer-remove.vue";
import ExpoProgramApply from "@/components/client/expo/programs/expo-program-apply.vue";

export default {
    components: {
        DialogLogin,
        ExpoProgramItem,
        ExpoProgramForm,
        ExpoEmployeeForm,
        ExpoEmployeeRemove,
        ExpoEmployerForm,
        ExpoEmployerRemove,
        ExpoProgramApply,
    },
    computed: {
        ...mapState("expo", ["program", "employee", "employer"]),
        ...mapGetters("expo", ["isUserHost"]),
        ...mapGetters(["isUserLoggedIn", "doesUserHaveConsoleScope"]),
    },
    methods: {
        ...mapActions("expo", ["init"]),
        ...mapMutations("expo", ["setProgram", "setEmployee", "setEmployer"]),

        setProgramAndInit(...props) {
            this.setProgram(...props);
            this.init();
        },
        setEmployeeAndInit(...props) {
            this.setEmployee(...props);
            this.init();
        },
        setEmployerAndInit(...props) {
            this.setEmployer(...props);
            this.init();
        },
    },
};
</script>

<style></style>
